import { ConsoleLogger } from "@fideus/logger";
import posthog from "posthog-js";

const logger = new ConsoleLogger();

let posthogInstance: typeof posthog | null = null;

interface PostHogConfig {
  publicKey: string;
  apiHost: string;
  uiHost: string;
}

export function initPosthog(config: PostHogConfig) {
  if (posthogInstance) {
    logger.info("PostHog has already been initialized");
    return posthogInstance;
  }

  posthog.init(config.publicKey, {
    api_host: config.apiHost,
    ui_host: config.uiHost,

    // We need to manually capture page views as this is an SPA,
    // and disabling this prevents double-tracking the first view
    capture_pageview: false,

    persistence: "localStorage+cookie",

    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
    },

    before_send: (event) => {
      if (
        event?.event === "$exception" &&
        event.properties?.$exception_message === "Failed to fetch"
      ) {
        // These are transient network errors (user offline, page navigation,
        // ad blockers) surfaced through PostHog's session replay network plugin.
        // They are not actionable and create noise in error tracking.
        return null;
      }
      return event;
    },
  });

  posthogInstance = posthog;

  return posthog;
}

export function getPosthog() {
  if (!posthogInstance) {
    logger.info("PostHog has not been initialized");
    return null;
  }
  return posthogInstance;
}
